import {useApiEndpoint} from "../../../../../lib/HttpService";
import {PATH} from "./const";
import {StubbornScreen} from "../../../../../application/business/StubbornAsset";

export const useEditionScreenApi = () => useApiEndpoint<StubbornScreen>(PATH);
